import { WifiOff, RefreshCw } from 'lucide-react';
import { useOfflineQueue } from '../../../hooks/useOfflineQueue';

/**
 * OfflineBanner (Tier 4.2)
 *
 * Shows a banner when the user is offline or when queued invoices are pending sync.
 * Renders nothing when online and queue is empty.
 */
export default function OfflineBanner() {
  const { isOnline, queueCount } = useOfflineQueue();

  if (isOnline && queueCount === 0) return null;

  if (!isOnline) {
    return (
      <div style={{
        display:        'flex',
        alignItems:     'center',
        gap:            '8px',
        padding:        '10px 16px',
        background:     '#1e293b',
        color:          '#f8fafc',
        fontSize:       '13px',
        fontWeight:     500,
        position:       'fixed',
        top:            0,
        left:           0,
        right:          0,
        zIndex:         9999,
      }}>
        <WifiOff size={15} />
        You are offline.
        {queueCount > 0
          ? ` ${queueCount} invoice${queueCount !== 1 ? 's' : ''} will sync when reconnected.`
          : ' New invoices will be saved and synced when connected.'}
      </div>
    );
  }

  // Online but still has pending items from a previous offline session
  return (
    <div style={{
      display:        'flex',
      alignItems:     'center',
      gap:            '8px',
      padding:        '10px 16px',
      background:     '#0284c7',
      color:          'white',
      fontSize:       '13px',
      fontWeight:     500,
      position:       'fixed',
      top:            0,
      left:           0,
      right:          0,
      zIndex:         9999,
    }}>
      <RefreshCw size={15} />
      Syncing {queueCount} offline invoice{queueCount !== 1 ? 's' : ''}…
    </div>
  );
}
